class ClientProperties {
    apiUrl = process.env.REACT_APP_API_URL;
    appName = "VENDING";
    appDashboardName = "VENDING";
    appNameShort = "V";
    companyName = "VENDING";
  }
  
  export const properties = new ClientProperties();